module.exports = __webpack_public_path__ + "static/media/$.08a0f4ed.svg";